module.exports = __webpack_public_path__ + "img/img3.22984333.png";